/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import "../src/app/custom.css";
import { initPostHog, trackPageView } from "../src/components/utils/posthog";
import { SSEDebugger } from "./utils/debugLogger";
import { store } from "./redux/store";

// Initialize PostHog
initPostHog();

const App = () => {
  // Track page views
  useEffect(() => {
    trackPageView();
    
    // Initialize SSE Debug Mode
    if (process.env.NODE_ENV === 'development') {
      // Create debug panel
      SSEDebugger.createDebugPanel();
      
      // Add global debug commands
      window.SSEDebug = {
        // Get current streaming state
        getStreamingState: () => {
          const state = store.getState();
          return state.ChatWithData.chat_with_data_res.data.filter(d => d.is_streaming);
        },
        
        // Get all debug logs
        getLogs: () => SSEDebugger.logs,
        
        // Enable/disable debug panel
        togglePanel: () => {
          const panel = document.getElementById('sse-debug-panel');
          if (panel) {
            panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
          } else {
            SSEDebugger.createDebugPanel();
          }
        },
        
        // Clear debug data
        clear: () => {
          SSEDebugger.clearLogs();
          SSEDebugger.updateDebugPanel('');
        }
      };
      
      // console.log('%c🔧 SSE Debug Mode Enabled', 'color: #00ff00; font-size: 14px; font-weight: bold;');
      // console.log('%cUse window.SSEDebug for debugging commands:', 'color: #00ff00; font-size: 12px;');
      // console.log('%c  - togglePanel(): Show/hide debug panel', 'color: #00ff00; font-size: 11px;');
      // console.log('%c  - getStreamingState(): View active streams', 'color: #00ff00; font-size: 11px;');
      // console.log('%c  - getLogs(): View all debug logs', 'color: #00ff00; font-size: 11px;');
      // console.log('%c  - clear(): Clear debug data', 'color: #00ff00; font-size: 11px;');
    }
  }, []);

  return (
    <Router>
      <Routes />
    </Router>
  );
};

export default App;
